import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { avgEngagementOnImpressionsPerTweetConfig } from '../avgEngagementOnImpressionsPerTweet';

export const mediaViewerEngagementOnImpressionsConfig = {
    ...avgEngagementOnImpressionsPerTweetConfig,
    id: 'engagement_on_impression',
    name: 'kpi.twitter.mediaviewer.engagement_on_impressions',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
